import './GenericResultView.css';

export const GenericResultView = ({ result }) => (
    <details>
        <summary>View result</summary>
        <pre className="grv-json">{JSON.stringify(result, null, 2)}</pre>
    </details>
);

export default GenericResultView;
